import { StringUtils } from './string.utils';

export abstract class ObjectUtils {

  /**
   * Compara dois dados de QUALQUER tipo
   * @param firstItem Primeiro item a ser comparado
   * @param secondItem Segundo item a ser comparado
   * @param params Caso os itens sejam funções, esses serão os parâmetros passados
   * @param limit Limite de recursões para impedir um loop em objetos autorreferenciáveis (default: 20)
   * @param timesCalled NÃO MEXA AQUI, TIRA A PATA >:(
   */
  public static equals<T>(firstItem: T, secondItem: T, limit = 20, timesCalled = 1): boolean {
    if (timesCalled > limit) {
      throw new Error('ObjectUtils.equals: Too many recursions');
    }

    for (const key in firstItem) {

      const prop1: any = firstItem[key] ?? false;
      const prop2: any = secondItem[key] ?? false;

      if (typeof prop1 !== typeof prop2) {
        return false;
      } else if (Array.isArray(prop1)) {
        for (let i = 0; i < prop1.length; i++) {
          if (!this.equals(prop1[i], prop2[i], limit, timesCalled + 1)) { return false; }
        }
      } else if (typeof prop1 === 'object') {
        if (!this.equals(prop1, prop2, limit, timesCalled + 1)) { return false; }
      } else if (typeof prop1 === 'function') {
        continue;
      } else {
        if (prop1 !== prop2) { return false; }
      }

    }

    return true;
  }

  public static recreate<T>(obj: T) {
    return JSON.parse(JSON.stringify(obj)) as T;
  }

  public static normalize<T>(obj: T & object, exceptions: string[] = []) {
    for (const key in obj) {
      if (typeof obj[key] === 'string' && !exceptions.includes(key)) {
        obj[key as string] = StringUtils.normalize(obj[key as string]);
      }
    }
    return obj
  }

  public static clone<T>(cloneThis: T, intoThis: T) {
    for (const key in intoThis) {
      delete intoThis[key];
    }
    for (const key in cloneThis) {
      intoThis[key] = cloneThis[key];
    }
    return intoThis;
  }

  public static arraysToObject(keys: string[], values: unknown[]) {
    const obj: any = {};
    Object.keys(keys).forEach((key, index) => {
      obj[key] = values[index];
    });
    return obj;
  }

}
